import React, { useEffect, useRef } from "react";

export default function MouseFX({ color = "255,255,255", opacity = 0.3 }) {
  const canvasRef = useRef(null);
  const rafRef = useRef();

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    let w = window.innerWidth, h = window.innerHeight;
    const dpr = window.devicePixelRatio || 1;
    canvas.width = w * dpr; canvas.height = h * dpr;
    canvas.style.width = w + "px"; canvas.style.height = h + "px";
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

    const effects = [];

    function resize() {
      w = window.innerWidth; h = window.innerHeight;
      canvas.width = w * dpr; canvas.height = h * dpr;
      canvas.style.width = w + "px"; canvas.style.height = h + "px";
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }
    window.addEventListener("resize", resize);

    function addRipple(x, y) {
      effects.push({ type: "ripple", x, y, life: 0, maxLife: 60 });
    }
    function addSpark(x, y) {
      effects.push({ type: "spark", x, y, life: 0, maxLife: 40 });
    }

    function onClick(e) {
      const { clientX: x, clientY: y } = e;
      addRipple(x, y);
      addSpark(x, y);
    }
    window.addEventListener("click", onClick);

    function frame() {
      ctx.clearRect(0, 0, w, h);

      for (let i = effects.length - 1; i >= 0; i--) {
        const p = effects[i];
        p.life++;
        const t = p.life / p.maxLife;

        if (p.type === "ripple") {
          const r = 10 + t * 80;
          ctx.strokeStyle = `rgba(${color},${opacity * (1 - t)})`;
          ctx.lineWidth = 2 * (1 - t);
          ctx.beginPath();
          ctx.arc(p.x, p.y, r, 0, Math.PI * 2);
          ctx.stroke();
        }

        if (p.type === "spark") {
          ctx.strokeStyle = `rgba(${color},${opacity * (1 - t)})`;
          ctx.lineWidth = 1.5;
          for (let j = 0; j < 6; j++) {
            const angle = (Math.PI * 2 * j) / 6;
            const len = 6 + t * 16;
            ctx.beginPath();
            ctx.moveTo(p.x, p.y);
            ctx.lineTo(p.x + Math.cos(angle) * len, p.y + Math.sin(angle) * len);
            ctx.stroke();
          }
        }

        if (p.life >= p.maxLife) effects.splice(i, 1);
      }

      rafRef.current = requestAnimationFrame(frame);
    }
    rafRef.current = requestAnimationFrame(frame);

    return () => {
      cancelAnimationFrame(rafRef.current);
      window.removeEventListener("resize", resize);
      window.removeEventListener("click", onClick);
    };
  }, [color, opacity]);

  return (
    <canvas
      ref={canvasRef}
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 9999,
        pointerEvents: "none",
      }}
    />
  );
}
